// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vGN6","label":"styles_label__15w86"};